const loginTranslation = {
  mode: 'ko',

  loginError: '로그인 오류',
  notAllowedErrorMessage1: '허용되지 않은 계정입니다.',
  notAllowedErrorMessage2: '담당 관리자에게 허용 요청 바랍니다.',
  loginErrorMessage1: '일시적인 서버 및 네트워크 오류입니다.',
  loginErrorMessage2: '잠시 후에 다시 시도해 주세요.',
  loginErrorMessage3: '로그인에 실패했습니다.',
  loginErrorMessage4: '관리자에게 문의 바랍니다.',
  keyLoginErrorMessage1: '키가 일치하지 않습니다.',
  keyLoginErrorMessage2: '다시 확인해 주세요.',
  adminUserNotFoundMessage1: '관리자 계정을 찾을 수 없습니다.',
  adminUserNotFoundMessage2: '계정 정보를 확인해 주세요.',
  configErrorMessage1: '로그인 설정 오류가 발생했습니다.',
  configErrorMessage2: '관리자에게 문의 바랍니다.',
  loginRetryMessage1: '로그인이 만료되었거나 실패했습니다.',
  loginRetryMessage2: '다시 로그인해 주세요.',
  permissionErrorMessage1: '접근 권한이 없습니다.',
  permissionErrorMessage2: '담당 관리자에게 권한 요청 바랍니다.',
  login: '라이프엑스 구글 로그인',
  inputKey: '키 입력',
  keyLogin: '키 로그인',
  keycloakLogin: '로그인',
  googleLogin: 'Google 로그인',
  logout: '로그아웃',
  redirecting: '로그인 페이지로 이동 중...',
  processingLogin: '로그인 처리 중...',
  redirectingToLogin: '로그인 페이지로 이동합니다...',
};

export default loginTranslation;
